import controller from './tracking.controller';
import templateBase from './templates/tracking-base.view.html';
import templateAD from './templates/tracking-adaptative.view.html';


let OrderDetailComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};
function changeTemplate() {
  if(__env.adaptative){
    return templateAD;
  } else {
    return templateBase;
  }
}


export default OrderDetailComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/orders/tracking/tracking.component.js
 **/